import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import config from 'config'
import PartnersState from '../../types/PartnersState'

export const partnersModule: Module<PartnersState, RootState> = {
  namespaced: true,
  state: {
    partners: [],
    listScope: null,
    current_partner_code: null,
    filterPartners: [],
    showFilterPartners: false,
    partnerLoader: false,
    categorySeoStats: { count: 0, avg_delivery_time: null, top_partners: [], loaded: false }
  },
  getters,
  actions,
  mutations
}
